import React, { lazy } from 'react'
import { ViewDeposit, ViewWithdraw } from '@/routes/preloadableModals'
import {
  accountUrl,
  walletUrl, 
  depositUrl,
  cashInConfirmationUrl,
  withdrawUrl, 
  withdrawValidationUrl,
  withdrawEmailReceivedUrl,
  personalInfoUrl,
  withdrawStatus,
  redeemCode,
  activityUrl,
} from '@/urls'
import { settingsUrl } from '@/urls'
// `ViewPersonalInfo` pulls in `wagmi` (useDisconnect); making it lazy keeps
// that off every chunk that statically imports the routes file.
const ViewPersonalInfo = lazy(() =>
  import('@/pages/personal-Info-form').then(m => ({ default: m.ViewPersonalInfo }))
)
// `ViewActivity` is lightweight on its own but transitively reaches notifications
// and infinite-grid; keeping it lazy avoids inflating every-page bundles.
const ViewActivity = lazy(() =>
  import('@/pages/activity').then(m => ({ default: m.ViewActivity }))
)

const ViewRedeemCode = lazy(() => import('@/pages/redeem-code').then(module => ({ default: module.ViewRedeemCode })))
const ViewPortfolio = lazy(() => import('@/pages/portfolio').then(module => ({ default: module.ViewPortfolio })))
const ViewWallet = lazy(() => import('@/pages/wallet') )
const ViewPublicProfile = lazy(() =>
  import('@/pages/public-profile').then(module => ({ default: module.ViewPublicProfile }))
)
const ViewWithdrawStatus = lazy(() => import('@/pages/withdraw-status'))  
const ViewCashInConfirmation = lazy(() => import('@/pages/cash-in-confirmation'))
const ViewSettings = lazy(() => import('@/pages/settings'))
const ViewUserList = lazy(() => import('@/pages/user-list'))
const ViewCryptoWithdrawValidation = lazy(() => import('@/pages/withdraw-validation'))
const ViewWithdrawEmailReceived = lazy(() => import('@/pages/withdraw-email-received'))
const ViewConvert = lazy(() => import('@/pages/convert/ViewConvert'))

export default [
  { path: walletUrl(), element: <ViewWallet /> },  
  { path: withdrawUrl(), element: <ViewWithdraw />, isModal: true },
  { path: personalInfoUrl(), element: <ViewPersonalInfo />, isModal: true },
  { path: withdrawEmailReceivedUrl(), element: <ViewWithdrawEmailReceived />, isModal: true },
  { path: withdrawValidationUrl(), element: <ViewCryptoWithdrawValidation />, isModal: true },
  { path: depositUrl(), element: <ViewDeposit />, isModal: true },
  { path: '/convert', element: <ViewConvert />, isModal: true },
  { path: withdrawStatus(), element: <ViewWithdrawStatus />, isModal: true },
  { path: cashInConfirmationUrl(), element: <ViewCashInConfirmation />, isModal: true },
  { path: redeemCode(), element: <ViewRedeemCode />, isModal: true },
  { path: accountUrl(), element: <ViewPortfolio /> },
  { path: settingsUrl(), element: <ViewSettings key="view-settings" /> },
  { path: settingsUrl(':setting'), element: <ViewSettings key="view-settings" /> },
  { path: '/:username/followers', element: <ViewUserList isFollowingList={false} key="view-user-followers" /> },
  { path: '/:username/following', element: <ViewUserList isFollowingList={true} key="view-user-following" /> },
  { path: '/:username', element: <ViewPublicProfile key="view-profile" /> },
  { path: activityUrl(), element: <ViewActivity /> },
]
